/** @flow */

import getElementoPorId from '../../utils/get-elemento-por-id';

const esconder = () => {
    getElementoPorId('container-graficos').style.display = 'block';
    getElementoPorId('container-grafico-horas').style.display = 'none';
    getElementoPorId('container-grafico-dia-da-semana').style.display = 'none';
    getElementoPorId('container-grafico-dias').style.display = 'none';
};

export default esconder;
